export class SearchContext {
    public selectedDateOffset: string;
    public selectedTaxonomies: string[];
    public selectedSortOption: string;

    constructor() {
        this.selectedDateOffset = '';
        this.selectedTaxonomies = [];
        this.selectedSortOption = 'a1';
    }

    
}


export const searchContext = new SearchContext();